import { BookingType } from "../../Booking-Form/typings/booking-inputs";
import type { BookingVehicleInfo } from "../../../components/FleetManagement/types/FleetManagement-row.types";
import type { BookableBookingObjectDto } from "../typings/resource-calendar.types";

/**
 * Shared cache read for resource-book vehicle fleet prefetch (see ScheduleResourceBookDialog).
 *
 * @returns `null` — not a vehicle row (caller should return `null` from the async prefetch helper).
 * @returns a value — reuse prefetched data or the in-flight promise for the same fetch key.
 * @returns `undefined` — no cache hit; caller should start a new fetch.
 */
export function tryReadVehicleInfoPrefetchCache(
  selectedRow: BookableBookingObjectDto | null,
  key: string,
  activeFetchKey: string,
  prefetched: BookingVehicleInfo | null,
  inflight: Promise<BookingVehicleInfo> | null
): BookingVehicleInfo | Promise<BookingVehicleInfo> | null | undefined {
  if (!selectedRow || selectedRow.bookingType !== BookingType.VEHICLE) {
    return null;
  }
  if (activeFetchKey !== key) {
    return undefined;
  }
  if (prefetched) {
    return prefetched;
  }
  if (inflight) {
    return inflight;
  }
  return undefined;
}
